import styled from "styled-components";



export const WheelDialogBgImgDefaultBox = styled.img`
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    
    @media ${({theme}) => `${theme.mediaQuery.xlAndAbove} or ${theme.mediaQuery.landscape}`} {
        transform: translate(-54.5%, -41%) scale(3.5);
    }
    transform: translate(-50.5%, -46%) scale(2.5);
`;